import { useEffect, useState } from 'react';
import {Container, Row, Col, Spinner} from 'react-bootstrap';
import { DefaultizedPieValueType } from '@mui/x-charts/models';
import { PieChart, pieArcLabelClasses } from '@mui/x-charts/PieChart';
import { BarChart } from '@mui/x-charts/BarChart';
import axios from 'axios';
import './dashboard.css'

const Dashboard = () => {

    const [dataPieReal, setDataPieReal]           = useState();
    const [dataPieUsuarios, setDataPieUsuarios]   = useState();
    const [dataPieMeses, setDataPieMeses]         = useState();
    const [dataInvitados, setDataInvitados]       = useState();
    const [showLoader, setShowLoader]             = useState(false);
  
    const DrawPie = () => {

      const sizing = {
          // margin: { right: 5 },
          width: 450,
          height: 200,
          legend: {
            hidden: false,
            labelStyle: {
              fontSize: 14,
              fill: 'gray',
            }
          }
      };

      const data = dataPieReal;
  
      const TOTAL = data.map((item) => parseInt(item.value)).reduce((a, b) => a + b, 0);
                  
      const getArcLabel = (params: DefaultizedPieValueType) => {
          const percent =  parseInt(params.value) / TOTAL;
          return `${(percent * 100).toFixed(0)}%`;
      };
  
      return (
          <>
          { 
              dataPieReal && (
              <PieChart
                      series={[
                        {
                          outerRadius: 80,
                          data,
                          arcLabel: getArcLabel,
                        },
                      ]}
                      sx={{
                        [`& .${pieArcLabelClasses.root}`]: {
                          fill: 'white',
                          fontSize: 12,
                        },
                      }}
                      {...sizing}
                      className='test_graf' />
              )
          }
          </>
      )
    }

    const DrawMeses =  () => {
  
    const sizing = {
        // margin: { right: 5 },
        width: 400,
        height: 350,
        legend: {
          hidden: false,
          labelStyle: {
            fontSize: 14,
            fill: 'gray',
          }
        }
    };

 
    return (
        <>
        { 
            dataPieMeses && (
                    <BarChart width={400}
                    height={350}
                    series={[{ data: dataPieMeses.values, label: 'Eventos mensuales', color: "#2AAA8A", id: 'cuack' }]} 
                    xAxis={[{ scaleType: 'band', data: dataPieMeses.labels }]}
                    {...sizing}
                    className='test_graf2' />
            )
        }
        </>
    )
    }

    const DrawInvitados = () => {

      const sizing = {
        // margin: { right: 5 },
        width: 400,
        height: 350,
        legend: {
          hidden: false,
          labelStyle: {
            fontSize: 14,
            fill: 'gray',
          }
        }
    };

 
    return (
        <>
        { 
            dataInvitados && (
              <BarChart
                width={400}
                height={350}
                series={[
                  { data: dataInvitados.values1, label: 'Capacidad', color: "#2AAA8A", id: 'pvId', stack: 'total' },
                  { data: dataInvitados.values2, label: 'Invitados',  color: "#088F8F", id: 'uvId', stack: 'total' },
                ]}
                xAxis={[{ data: dataInvitados.labels, scaleType: 'band' }]}
                {...sizing}
                className='test_graf2'
              />
            )
        }
        </>
    )



      
    }

    const DrawPieUsuarios = () => {
  
    const sizing = {
        // margin: { right: 5 },
        width: 450,
        height: 200,
        legend: {
          hidden: false,
            labelStyle: {
              fontSize: 14,
              fill: 'gray',
            }
        }
    };

    const data = dataPieUsuarios;

    const TOTAL = data.map((item) => parseInt(item.value)).reduce((a, b) => a + b, 0);
                
    const getArcLabel = (params: DefaultizedPieValueType) => {
        const percent =  parseInt(params.value) / TOTAL;
        return `${(percent * 100).toFixed(0)}%`;
    };

    return (
        <>
        { 
            dataPieUsuarios && (
            <PieChart
                    series={[
                      {
                        outerRadius: 80,
                        data,
                        arcLabel: getArcLabel,
                      },
                    ]}
                    sx={{
                      [`& .${pieArcLabelClasses.root}`]: {
                        fill: 'white',
                        fontSize: 12,
                      },
                    }}
                    {...sizing}
                  
                    className='test_graf'
                  />
            )
        }
        </>
    )
    }

    useEffect(()=>{
      
      const getGraphData = async () => {
        
          setShowLoader(true);
          let ud = sessionStorage.getItem('userData');
          let userData = JSON.parse(ud);
  
          const instance = axios.create({
            baseURL: '',
            timeout: 10000,
            headers: {'content-type': 'application/json', 'Authorization': 'Bearer '+userData.access_token}
          });
  
          await instance.get('api/get-data-pie')
          .then(response => {
              const colores = [];
              colores.push("#2AAA8A", "#088F8F", "#097969", "#AFE1AF", "#00FFFF");
              var nuevo = JSON.parse(JSON.stringify(response.data))
          
              Object.keys(nuevo).forEach(function(element, index) {
                  nuevo[element].color  = colores[index];
              });
              setDataPieReal(nuevo)
          });
  
          await instance.get('api/get-data-usuarios')
          .then(response2 => {

              const colores = [];
              colores.push("#2AAA8A", "#088F8F", "#097969", "#AFE1AF", "#00FFFF");
              var nuevo2 = JSON.parse(JSON.stringify(response2.data))
          
              Object.keys(nuevo2).forEach(function(element, index) {
                  nuevo2[element].color  = colores[index];
  
                  if(nuevo2[element].label === 0)
                    nuevo2[element].label = "Mesero"
                  if(nuevo2[element].label === 1)
                    nuevo2[element].label = "Control de acceso"
                  if(nuevo2[element].label === 2)
                    nuevo2[element].label = "Administrador"
              });

              setDataPieUsuarios(nuevo2)
          });

          await instance.get('api/get-data-meses')
          .then(response3 => {
              var nuevo3 = JSON.parse(JSON.stringify(response3.data))
              setDataPieMeses(nuevo3)
          })

          await instance.get('api/get-invitados-data')
          .then(response4 => {
              var nuevo4 = JSON.parse(JSON.stringify(response4.data))
              setDataInvitados(nuevo4)
              console.log(nuevo4)
          })

          setTimeout(() => {
            setShowLoader(false);
          }, "1000");

      }

      getGraphData();
    },[]);

  return (<>
            <Container>
              {
                showLoader ? 
                    <div className='loader-div2'>
                    
                        <Spinner animation="border" className='spinner_color' color={'#097969'} role="status">
                            <span className="visually-hidden">Loading...</span>
                        </Spinner><br />
                        <h3 className='loading_txt'>Loading App settings...</h3>
                    </div> : ""
                }
                <h1 className="mt-4">Dashboard</h1>
                {/* <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
                */}
                <Row className='mt-5'> 
                    <Col className='centrar text-center'>
                    <h4>Eventos por venue</h4>
                    { 
                        dataPieReal && (
                            <DrawPie />
                        )
                    }
                    </Col>
                    <Col className='centrar text-center'>
                    <h4>Usuarios activos</h4>
                    { 
                        dataPieUsuarios && (
                            <DrawPieUsuarios />
                        )
                    }
                    </Col>
                </Row> 
                <Row className='mt-5'>
                  <Col className='centrar text-center'>
                  <h4>Actividad Meses</h4>
                    { 
                        dataPieMeses && (
                            <DrawMeses />
                        )
                    }
                  </Col>
                  <Col className='centrar text-center'>
                    <h4>Invitados por evento</h4>
                    { 
                        dataInvitados && (
                            <DrawInvitados />
                        )
                    }
                  </Col>
                </Row>
            </Container>
           
  </>);
};

export default Dashboard;